{
  "version": 1,
  "asset_id": "64f324db-3d9e-4a91-a33f-6290d224d7bc",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/64f324db-3d9e-4a91-a33f-6290d224d7bc/raindrop-impact.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/64f324db-3d9e-4a91-a33f-6290d224d7bc/raindrop-impact.mp4",
  "original_filename": "raindrop-impact.mp4",
  "size": 10663204,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:34Z"
}
